import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/core/service/auth.service";
import { CallApiService } from "src/app/core/service/call-api.service";
import { GlobalService } from "src/services/global.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
@Injectable({
  providedIn: 'root'
})
export class PharmacyService {
  data = new FormData();
  currentUser
  currentUser1: string;
  authentication_token
  // authentication_token
  constructor(
    private callAPI: CallApiService,
    private global: GlobalService,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private http: HttpClient,
    private _global: GlobalService,
  ) {
    this.currentUser = this.authService.currentUserValue.store_id
    this.currentUser1 = this.authService.currentUserValue.user_role
    // console.log(this.authentication_token);
  }
  // Http Options
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${localStorage.getItem('authentication_token')}`,
      'Accept-Language': localStorage.getItem('lang') ? localStorage.getItem('lang')! : 'en'
      // 'authorization': this.authService.currentUserValue.access_token
    })
  }

  //-----------------Profile Section-------------------
  getProfile(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/profile', data, this.httpOptions)
  }
  editProfile(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/profile-update', data, this.httpOptions)
  }
  changepassword(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/change-password', data, this.httpOptions)
  }
  edit_address(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/address-update', data, this.httpOptions)
  }
  //------------------ My Items -----------------

  medicine_list(data) {
    data.append('store_id', this.currentUser);
    // console.log(this.currentUser)
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/get-all-medicines', data, this.httpOptions)
  }

  categoryList(data) {
    data.append('store_id', this.currentUser);
    // console.log(this.currentUser)
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/get-medicine-categories', data, this.httpOptions)
  }
  subcategoryList(data) {
    data.append('store_id', this.currentUser);
    // console.log(this.currentUser)
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/get-medicine-sub-categories', data, this.httpOptions)
  }
  add_medicine(data) {
    data.append('store_id', this.currentUser);
    data.append('user_role', this.currentUser1);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/add-medicine', data, this.httpOptions)
  }
  update_medicine(data) {
    data.append('store_id', this.currentUser);
    data.append('user_role', this.currentUser1);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/update-medicine', data, this.httpOptions)
  }
  getAllMedicinesDetails(data) {
    data.append('store_id', this.currentUser);
    data.append('user_role', this.currentUser1);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/get-medicine-info', data, this.httpOptions)
  }
  activeInactiveMedicine(data) {
    data.append('store_id', this.currentUser);
    data.append('user_role', this.currentUser1);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/change-status', data, this.httpOptions)
  }
  //-----------------Wallet Section--------------------------
  //Current balance
  current_balance(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/current-balance", data, this.httpOptions);
  }
  //Transaction History
  transaction_history(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/wallet-transactions", data, this.httpOptions);
  }
  // Add Money to wallet
  add_money_to_wallet(data) {
    data.append("language", this.translate.currentLang);
    data.append('store_id', this.currentUser);
    data.append('user_role', this.currentUser1);
    return this.callAPI._postAPI("/pharmacy/add-to-wallet", data, this.httpOptions);
  }
  //Withdrwal History
  withdrawal_transaction_history(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/withdrawal-transactions", data, this.httpOptions);
  }
  //Withdrwal Request
  withdrawal_request(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/send-withdrawal-request", data, this.httpOptions);
  }
  // ========================================================================================
  //Order Fuctionality
  get_order(data) {
    data.append("language", this.translate.currentLang);

    return this.callAPI._postAPI("/pharmacy/get-all-pharmacist-orders", data, this.httpOptions);
  }
  get_prescriptions(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/get-requested-prescription-list", data, this.httpOptions);
  }
  quotation_order(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/accept-reject-recieved-order", data, this.httpOptions);
  }
  get_prescription_info(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/get-requested-prescription-info", data, this.httpOptions);
  }
  prescriptions_accep_reject(data) {
    data.append("language", this.translate.currentLang);

    return this.callAPI._postAPI("/pharmacy/accept-reject-requested-prescription", data, this.httpOptions);
  }
  get_order_info(data) {
    data.append("language", this.translate.currentLang);

    return this.callAPI._postAPI("/pharmacy/get-order-info", data, this.httpOptions);
  }
  send_quotation(data) {
    data.append("language", this.translate.currentLang);

    return this.callAPI._postAPI("/pharmacy/send-requested-prescription-quotation", data, this.httpOptions);
  }
  order_accept_reject(data) {
    data.append("language", this.translate.currentLang);

    return this.callAPI._postAPI("/pharmacy/accept-reject-recieved-order", data, this.httpOptions);
  }
  complete_order(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/mark-complete-order", data, this.httpOptions);
  }
  order_invoice(data) {
    data.append("language", this.translate.currentLang);

    return this.callAPI._postAPI("/view-order-invoice", data);
  }
  active_deliveryman(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/active-delivery-man-list", data, this.httpOptions);
  }
  assign_deliveryman(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/pharmacy/assign-delivery-man", data, this.httpOptions);
  }
  //Static Page Content
  //Withdrwal Request
  terms_and_condition(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/admin/get-term-condition-content", data, this.httpOptions);
  }
  //Notifiction Api
  pharmacy_notification(data) {
    // data.append('receiver_id', this.authService.currentUserValue.id);

    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/admin/get-all-notifications', data, this.httpOptions)
  }

  // Contact Us API
  contact_us(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/admin/send-support-email', data, this.httpOptions)
  }
  //Dashboard Appointment graph
  get_graph(data) {
    data.append("language", this.translate.currentLang);
    data.append('login_id', this.currentUser);
    data.append('user_role', this.currentUser1);
    return this.callAPI._postAPI("/pharmacy/get-order-graph", data, this.httpOptions);
  }
  // QR Code Scanner API
  QR_code_scanned(data) {
    data.append('medical_store_id', this.currentUser);
    data.append('store_role', this.authService.currentUserValue.role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/send-prescription-access-request', data, this.httpOptions);
  }
  // validate_access_request_pin
  validate_access_request_pin(data) {
    data.append('medical_store_id', this.currentUser);
    data.append('store_role', this.authService.currentUserValue.role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/pharmacy/validate-access-request-pin', data, this.httpOptions);
  }
  mtn_pay_request(data) {
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.role.toLowerCase());
    return this.callAPI._postAPI("/mtn-pay-request", data, this.httpOptions);
  }
  quotationList(data) {
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI("/pharmacy/received-quotations-list", data, this.httpOptions);
  }
  quotation_info(data) {
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.role.toLowerCase());
    return this.callAPI._postAPI("/pharmacy/quotations-info", data, this.httpOptions);
  }
}
